import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { AppRoutes } from '@shared/constants/app-routes.const';
import { RestapiServiceWithoutTimezone } from 'src/app/services/restapi.service';

@UntilDestroy()
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent extends ComponentAbstract implements OnInit, OnDestroy {
  constructor(
    protected cdr: ChangeDetectorRef,
    public oidcSecurityService: OidcSecurityService,
    private apiService: RestapiServiceWithoutTimezone,
    private route: ActivatedRoute
  ) {
    super(cdr);
  }

  ngOnInit() {
    this.wakeApp().subscribe();
  }

  ngOnDestroy(): void {}

  private wakeApp(): Observable<any> {
    return this.apiService.getData<any>('Wake').pipe(
      tap(() => {
        const returnUrl = this.route.snapshot.queryParams.returnUrl
          //We needn't a origin for navigation inside angular app
          ?.replace(window.location.origin, '')
          //oidcSecurityService can not work with '&' symbol and will corrupt state if will be inside the string
          .replace(/&/g, '??');
        this.oidcSecurityService
          .setState(returnUrl || AppRoutes.HOME)
          .subscribe(() => this.oidcSecurityService.authorize());
      })
    );
  }
}
